// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2WhG9","rowsWrapper":"style_rowsWrapper__3CYZ6","rowWrapper":"style_rowWrapper__2W3St","text":"style_text__2stsD"};